import { handleLaunchBrowser } from '@/utils/launchBrowser'
import { Button } from '../ui/button'
import { Modal, ModalProps } from './Modal'

import IconAttention from '@/assets/icons/ic_logic-g-app_attention.svg'

interface Props extends ModalProps {
  platform: 'ios' | 'android'
  forceUpdate: boolean
}

export const ApplicationUpdateModal = ({
  platform,
  forceUpdate,
  ...rest
}: Props): JSX.Element => {
  return (
    <Modal
      customStyles={{
        content: {
          padding: '48px 15px',
        },
      }}
      showCloseButton={!forceUpdate}
      shouldCloseOnOverlayClick={!forceUpdate}
      {...rest}
    >
      <h3 className="mb-[15px] mt-[10px] text-center text-2xl font-bold tracking-widest text-primary-text">
        {forceUpdate ? 'アプリを更新してください' : 'アプリを更新しますか？'}
      </h3>

      <p className="text-center text-[15px] font-medium tracking-widest text-secondary-text">
        {forceUpdate
          ? 'アプリの新しいバージョンがあります。更新してください'
          : 'アプリの新しいバージョンがあります。\n更新しますか？'}
      </p>

      <div className="mt-5 flex justify-center text-[#D7DDF3]">
        <IconAttention width={104} aria-hidden={true} />
      </div>

      <div className="mt-5 flex justify-center gap-4">
        <Button
          variant="secondary"
          className="w-full max-w-[200px]"
          onClick={() => {
            handleLaunchBrowser(
              platform == 'ios'
                ? 'https://apps.apple.com/jp/app/logiq-labo-ロジックラボ-保護者専用アプリ/id6472258185'
                : 'https://play.google.com/store/apps/details?id=com.sonyged.logic.guardian'
            )
          }}
        >
          更新する
        </Button>
      </div>
    </Modal>
  )
}
